/* ─── Pelabuhan design language: shared dashboard surfaces ──────────────
   Reusable card treatments. Pick the one that matches the surface's role:
     • heroCard   — frosted glass on tinted backdrop (greeting/banner)
     • paperCard  — subtle cream texture (default content surface)
     • accentCard — filled deep-sea (1 per page max, for "featured" data)
     • frameCard  — border-only (data tables / transparent containers)
   ────────────────────────────────────────────────────────────────────── */

.heroCard {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  padding: 28px;
  background: light-dark(
    linear-gradient(135deg, #fffdf8 0%, rgba(232, 213, 183, 0.4) 100%),
    linear-gradient(135deg, #102129 0%, rgba(14, 124, 123, 0.18) 100%)
  );
  border: 1px solid light-dark(rgba(232, 213, 183, 0.6), rgba(14, 124, 123, 0.18));
  box-shadow: light-dark(0 4px 24px -8px rgba(14, 124, 123, 0.12), 0 4px 24px -8px rgba(0, 0, 0, 0.6));
}

.heroOmbak {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 24px;
  color: light-dark(var(--mantine-color-laut-6), var(--mantine-color-laut-4));
  pointer-events: none;
}

.heroContent {
  position: relative;
  z-index: 1;
}

.displayHeading {
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.05;
  color: light-dark(var(--mantine-color-navy-8), var(--mantine-color-kertas-1));
}

.tabularNumber {
  font-variant-numeric: tabular-nums;
}

/* Card treatments — apply on top of Mantine Card via className */

.paperCard {
  background: light-dark(#fbf7ee, var(--mantine-color-dark-6));
  border: 1px solid light-dark(rgba(168, 150, 121, 0.18), rgba(31, 57, 66, 0.6));
}

.accentCard {
  background: linear-gradient(135deg, var(--mantine-color-laut-6) 0%, var(--mantine-color-laut-7) 100%);
  border: 1px solid var(--mantine-color-laut-7);
  color: white;
}

.accentCard * {
  color: white;
}

.frameCard {
  background: transparent;
  border: 1px solid light-dark(var(--mantine-color-pasir-2), var(--mantine-color-dark-4));
  box-shadow: none;
}

/* Motion utilities — opt-in via className */

.stagger > * {
  opacity: 0;
  transform: translateY(8px);
  animation: rise 420ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.stagger > *:nth-child(1) {
  animation-delay: 60ms;
}
.stagger > *:nth-child(2) {
  animation-delay: 140ms;
}
.stagger > *:nth-child(3) {
  animation-delay: 220ms;
}
.stagger > *:nth-child(4) {
  animation-delay: 300ms;
}
.stagger > *:nth-child(5) {
  animation-delay: 380ms;
}
.stagger > *:nth-child(6) {
  animation-delay: 460ms;
}

@keyframes rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.liftOnHover {
  transition:
    transform 200ms cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 200ms ease;
}

.liftOnHover:hover {
  transform: translateY(-2px);
  box-shadow: light-dark(0 12px 32px -12px rgba(14, 124, 123, 0.25), 0 12px 32px -12px rgba(0, 0, 0, 0.6));
}

@media (prefers-reduced-motion: reduce) {
  .stagger > * {
    opacity: 1;
    transform: none;
    animation: none;
  }
  .liftOnHover {
    transition: none;
  }
}
